import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as actions from '../../../../redux/projects/actions.projects';
import * as _ from 'lodash';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ProjectTile from '../ProjectTile/ProjectTile';
import isLocalStorageAvailable from '../../../../services/mini/isLocalStorageAvailable';
import arrayMove from '../../../../services/mini/arrayMove';
// @ts-ignore
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import ProjectVideoTile from '../ProjectTile/ProjectVideoTile';
import NewProjectTemplatePopup from '../NewProjectTemplatePopup/NewProjectTemplatePopup';
import store from '../../../../store';
import { IProject } from '../../../../models/IProject';
import { ConnectedProps, connect } from 'react-redux';
import { IStore } from '../../../../redux/initialState';
const { default: plusSign } = require('../../../../assets/images/projects/plus-sign-big.svg');

const DragHandle = sortableHandle(() => <div className="project-tile__drag-handler"><i className="icon icon-drag-icon"></i></div>);
const SortableItem = sortableElement(({
    project,
    stats,
    projects,
    index,
    movingTileIndex,
}) => project.type === 'video' ?
        <ProjectVideoTile
            project={project}
            dragHandler={<DragHandle />}
            movingTileIndex={movingTileIndex}
            projects={projects} />
        : <ProjectTile
            // @ts-ignore
            stats={stats}
            project={project}
            dragHandler={<DragHandle />}
            movingTileIndex={movingTileIndex}
            highlightWhenMoving={movingTileIndex === index}
            projects={projects} />);

const SortableContainer = sortableContainer(({ children }) => {
    return <div className="projects-table_tile-holder">{children}</div>;
});

type ProjectsTableProps = PropsFromRedux & {
}

type ProjectsTableState = {
    projects: IProject[]
    movingTileIndex: number
}

class ProjectsTable extends React.Component<ProjectsTableProps, ProjectsTableState> {
    wasScrolledToSavedPos: boolean;
    constructor(props) {
        super(props);

        this.state = {
            projects: this.props.projects,
            movingTileIndex: null
        };

        this.wasScrolledToSavedPos = false;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ projects: nextProps.projects });
    }

    componentDidMount() {
        this.scrollToDefaultPosition();
    }

    scrollToDefaultPosition = () => {
        const projectTable = ReactDOM.findDOMNode(this.refs.projectTable) as HTMLDivElement;
        const { userEmail } = this.props;
        if (userEmail && !this.wasScrolledToSavedPos && isLocalStorageAvailable()) {
            projectTable.scrollTop = +localStorage.getItem(`alan-projects-scroll-top-${userEmail}`);
            this.wasScrolledToSavedPos = true;
        }
    }

    scrollRemember = (y) => {
        const { userEmail } = this.props;

        if (userEmail && isLocalStorageAvailable()) {
            localStorage.setItem(`alan-projects-scroll-top-${userEmail}`, y);
        }
    }

    rememberScroll = _.debounce(this.scrollRemember, 300)

    onScroll = (e) => {
        this.rememberScroll(e.target.scrollTop);
    }

    createNewProject = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <NewProjectTemplatePopup
                        onClose={onClose}
                        store={store} />
                );
            }
        });
    }

    onSortStart = ({ node, index, collection, isKeySorting }, event) => {
        this.setState({
            movingTileIndex: index
        });
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { projects } = this.state;
        const newProjects = arrayMove(projects, oldIndex, newIndex);
        this.setState({
            projects: newProjects,
            movingTileIndex: null
        });
        this.props.reorderProjects({ projects: newProjects });
    }

    render() {
        const { projects, movingTileIndex } = this.state;
        const {
            projectsStats,
        } = this.props;

        return (
            <div className="projects-table"
                ref="projectTable"
                onScroll={this.onScroll}>
                <SortableContainer onSortEnd={this.onSortEnd} onSortStart={this.onSortStart} axis="xy" useDragHandle>
                    {projects.map((project, index) => {
                        let stats = {};
                        if (project && projectsStats) {
                            stats = projectsStats[project.projectId];
                        }

                        return <SortableItem
                            key={project.projectId}
                            index={index}
                            movingTileIndex={movingTileIndex}
                            project={project}
                            projects={projects}
                            stats={stats}
                        />;
                    })}
                </SortableContainer>
                <div className="projects-table_add-new" onClick={this.createNewProject}>
                    <img src={plusSign} />
                    <div className="projects-table_add-new_label">Create Project</div>
                </div>
            </div>
        );
    }
}


function mapStateToProps({ projectsInfo, user }: IStore, ownProps) {
    const projects = projectsInfo.projects;
    let hasFilledRunOnProdVersion = false;

    for (var i = 0; i < projects.length; i++) {
        if (projects[i].prodTagName) {
            hasFilledRunOnProdVersion = true;
            break;
        }
    }

    return {
        projects: projectsInfo.projects,
        projectsStats: projectsInfo.projectsStats,
        userEmail: user.email,
        hasFilledRunOnProdVersion: hasFilledRunOnProdVersion,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        reorderProjects: (param) => dispatch(actions.reorderProjects(param)),
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ProjectsTable);

